import { PaginationInputDto } from "@/model/common/PaginatedInputDto";
import { post } from "../../utils/BaseService";

export async function getAllCountries(dispatch: any, props: PaginationInputDto) {
  return await post(dispatch, '/Country/getAllCountries', props);
}